export class GroupedResponse<T> {
  [key: string]: T
}

export class GroupedResponseTwoLevels<T> {
  [key: string]: GroupedResponse<T>
}

export class GroupedResponseThreeLevels<T> {
  [key: string]: GroupedResponseTwoLevels<T>
}
